import React from "react";
import PropTypes from "prop-types";
import FailIcon from "@common/images/AlertLargeFail.svg";
import { Image } from "@learningblocks/shared-components/lib/Image";
import { Button } from "@learningblocks/shared-components/lib/Button";
import style from "./style.module.scss";

/**
 * ErrorBlock
 *  - The error state template display for glossary component.
 */
export function ErrorBlock(props) {
  return (
    <div className={`${style.errorMessage} ${props.className}`}>
      <Image src={props.image} alt={props.title} />
      <h3>{props.title}</h3>
      <p>{props.details}</p>
      <Button onClick={props.onRetry}>Retry</Button>
    </div>
  );
}

ErrorBlock.propTypes = {
  /**
   * Classname to be set for the wrapper function
   */
  className: PropTypes.string.isRequired,
  /**
   * Error icon to be displyed
   */
  image: PropTypes.string.isRequired,
  /**
   * Title for the error message
   */
  title: PropTypes.string.isRequired,
  /**
   * Detailed description for error message
   */
  details: PropTypes.string.isRequired,
  /**
   * Function to be executed when on click of retry
   */
  onRetry: PropTypes.func.isRequired,
};

ErrorBlock.defaultProps = {
  image: FailIcon,
  title: "Content Not Loading",
  details: "Please try clicking the reload button.",
};
